import { RootState } from "@/store/types";
import axios from "axios";
import { ActionTree } from "vuex";
import { DetailFilterParams, GroupFilterParams, StatisticState } from "./types";

export const actions: ActionTree<StatisticState, RootState> = {
  async getPushStatisticDetail({commit}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/push",
        params: data,
      });
      let messages = resp.data?.messages ?? []
      if (data.page_number > 1) {
        commit("pushPushStatisticDetail", messages);
      } else {
        commit("setPushStatisticDetail", messages);
      }
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportPushStatisticDetail({commit}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/push/export",
        params: data,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getPushStatisticDetailInfo({ commit, dispatch }, id: string) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/push/" + id.replace(/#/g, "%23"),
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getPushStatisticGroup({commit}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/group/push",
        params: data,
      });
      commit("setPushStatisticGroup", resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportPushStatisticGroup({commit}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/group/push/export",
        params: data,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
};